import { render } from "./item-details.vue?vue&type=template&id=c1ec14de&scoped=true&ts=true"
import script from "./item-details.vue?vue&type=script&lang=ts"
export * from "./item-details.vue?vue&type=script&lang=ts"

import "./item-details.vue?vue&type=style&index=0&id=c1ec14de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ec14de"]])

export default __exports__